import React, { useEffect, useRef } from "react";
import ReactDOM from 'react-dom';
import { MathJax, MathJaxContext } from "better-react-mathjax";

const mathJaxConfig = {
    loader: { load: ["input/tex", "output/chtml"] },
    tex: {
      inlineMath: [["$", "$"], ["\\(", "\\)"]],
      displayMath: [["$$", "$$"], ["\\[", "\\]"]],
      processEscapes: true,
    },
  };
  
  const formatMathJax = (htmlString) => {
    return htmlString
      .replace(/@@\[(.*?)\]@@/g, (_, latex) => `\\(${latex}\\)`) 
      .replace(/@\[(.*?)\]@/g, (_, latex) => `\\(${latex}\\)`) 
      .replace(/(?<!\\)\$/g, "\\$"); 
  };


const CompanionQuestions = ({ show, onClose, data }) => {

  const printRef = useRef(null);

  const getColor = (standardsType) => {
    switch (standardsType) {
      case 'Readiness':
        return 'green';
      case 'Supporting':
        return 'orange';
      case 'Process':
        return 'purple';
      default:
        return 'none';
    }
  };

  
  useEffect(() => {
    if (window.MathJax && typeof window.MathJax.typesetPromise === "function") {
      window.MathJax.typesetPromise();
    }
  }, [data]); 

  if (!show) return null;

  let lastPassageKey = null;

  const handlePrint = () => {
    if (printRef.current) {
      const docName = data.referenceDocumentName || "Document"; 
      //document.title = docName;

      const answerKeyTable = `
      <div class="answer-key">
        <div class="answer-key-header">Answer Key</div>
        <table>
          ${data.questions.map((curr, index) => {
            const answerText = curr.questionType === 1
              ? curr.answers.filter(x => x.correct).map(x => x.answerLetter).join(", ")
              : curr.answers.filter(x => x.correct).map(x => x.answerText).join(", ");

            return index % 5 === 0
              ? `<tr><td><num>${curr.questionNumber}.</num> <answer>${answerText}</answer></td>`
              : index % 5 === 4
              ? `<td><num>${curr.questionNumber}.</num> <answer>${answerText}</answer></td></tr>`
              : `<td><num>${curr.questionNumber}.</num> <answer>${answerText}</answer></td>`;
          }).join("")}
        </table>
        
        <table align="right">
          <tr><td align="right">${data.documentDesc}</td></tr>
        </table>
      </div>
    `;

      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>${docName}</title>
            <style>
              body { font-family: Arial, sans-serif; margin: 20px; }
              .modal-header, .modal-footer { 
                background-color: #519B52; 
                color: white; 
                text-align: center; 
                font-size: 16px; 
                font-weight: bold; 
                padding: 10px; 
              }
              .modal-body { padding: 20px;
               }

              @page {
                margin: 5mm; /* Keeps margins for borders */
                size: auto; /* Ensures full-page printing */
              }

              @media print {
                        .print-content {
            font-size: 22px !important; /* Force font size increase */
            line-height: 1.6 !important; /* Improve readability */
          }
                body {
                    height: 100%;
                    margin: 0;
                    font-family: Arial, sans-serif;
                }

                  .MathJax, .mjx-chtml {
                    font-family: Arial, sans-serif !important;
                    font-size: 18px !important;
                    font-weight: inherit !important;
                    line-height: inherit !important;
                    color: inherit !important;
                  }

                .modal-body {
                    margin: 0;
                    padding: 10px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    page-break-inside: avoid;
                }

                td, th {
                    padding: 5px;
                    border: 1px solid black;
                }

                .answer-key {
                    display: block;
                    page-break-before: always;
                }

                .answer-key-header {
                    color: white;
                    font-size: 18px;
                    padding: 4px;
                    background-color: black;
                }

                .answer-key table {
                    margin-top: 5px;
                }

                .answer-key td {
                    padding: 2px;
                }

                .answer {
                    margin-left: 4px;
                }

                /* Cover Page Styling */
                .cover-page {
                    page-break-after: always;
                    height: 90.7%;
                    padding: 5%;
                    margin: 0 auto;
                    border: 1px solid black;
                    border-radius: 5px;
                    text-align: center;
                    position: relative;
                }

                .district-name {
                    display: block;
                    font-size: 4em;
                    font-weight: bold;
                    text-align: center;
                }

                .department {
                    display: block;
                    font-size: 2em;
                    text-align: center;
                }

                .cover-logo {
                    display: block;
                    margin: 2% auto;
                    width: 50%;
                }

                .subject {
                    display: block;
                    font-size: 3em;
                    text-align: center;
                    font-weight: bold;
                }

                .document-description {
                    display: block;
                    font-size: 1.5em;
                    text-align: center;
                }

                  .documentdesc {
                    display: block;
                    font-size: 1.5em;
                    text-align: center;
                  }

                    .cover-logo {
                      position: absolute;
                      bottom: 0%;
                      left: 0%;
                      height: 7%;
                      width: 25%;
                      background-color: black;
                      color: white;
                      text-align: center;
                      border-top-left-radius: 5px;
                      img {
                        margin-top: 7%;
                        margin-left: auto;
                        margin-right: auto;
                        display: block;
                        width: 70%;
                      }
                    }

                .cover-footer {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    height: 7%;
                    width: 74.7%;
                    background-color: black;
                    color: white;
                    text-align: center;
                    border-top-right-radius: 5px;
                }

                .cover-footer-text {
                    margin-top: 1%;
                    display: block;
                    text-align: center;
                    font-size: 2em;
                }

                .copyright {
                    display: block;
                    text-align: center;
                    font-size: 0.8em;
                    margin-top: -3%;
                }
              }
            </style>
          </head>
          <body>
            <!-- Cover Page -->
            <div class="cover-page">
              <p class="district-name">TANGO TRENDS</p>
              <img class="coverimage" src="${data.imageURL}" alt="District Logo" />
              <p class="subject">${data.subject}</p>
              <p class="documentdesc">
                Companion Document for <br/>
                ${data.referenceDocumentName}<br/>
                ${data.documentDesc}
              </p>
              <div class="cover-logo">
              <img src="https://files.tangosoftware.com/DataDrive1/TangoCentral/KentroPDFTemplate/TangoCoverLogo.png" alt="Tango Logo" />
              </div>
              <div class="cover-footer">
                <p class="cover-footer-text">Academic Readiness Assessment</p>
                <p class="copyright">
                  Copyright © 2014, Liberty Source LLC. All Rights Reserved. 
                  Reproduction of all or portions of this work is prohibited.
                </p>
              </div>
            </div>
  
            <hr />
  
            <div class="modal-body print-content">${printRef.current.innerHTML}</div>
            ${answerKeyTable}
          </body>
        </html>
      `);
      printWindow.document.close();
      const images = printWindow.document.images;
      let loadedImages = 0;
      
      if (images.length === 0) {
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
  }, 500);
        return;
      }
  
      for (let img of images) {
        img.onload = () => {
          loadedImages++;
          if (loadedImages === images.length) {
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
  }, 500);
          }
        };
        img.onerror = () => {
          loadedImages++;
          if (loadedImages === images.length) {
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
  }, 500);
          }
        };
      }
    }
  };


  return ReactDOM.createPortal(
    <MathJaxContext config={mathJaxConfig}>
    <div
    className="modal-overlay"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)', 
      zIndex: 9999,
    }}
    onClick={onClose}
  >
    <div
      className="modal-content"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '10px',
        maxWidth: '80%',
        maxHeight: '80%',
        overflow: 'hidden', 
        display: 'flex',
        flexDirection: 'column', 
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        zIndex: 10000,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {/* Fixed Header */}
      <div
        className="modal-header"
        style={{
          position: 'sticky', 
          top: 0,
          left: 0,
          right: 0,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: '#519B52', 
          color: 'white',
          fontWeight: 'bold',
          fontSize: '16px',
          height: '50px', 
          padding: '0 20px', 
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          zIndex: 1, 
        }}
      >
        <span>Companion Questions</span>
        <span
          onClick={onClose}
          style={{
            cursor: 'pointer',
            fontSize: '25px',
            color: 'white',
          }}
        >
          &times;
        </span>
      </div>

        <div
         className="modal-body"
         style={{
           flex: 1, 
           padding: '20px', 
           overflowY: 'auto', 
         }}
         ref={printRef}
        >

        <style>
        {`
          .AllFailed { color: #bf0000; }
          .AllPass { color: #1a7b3c; }
          .ADVPlus { color: #474e96; }
          .ADV { color: #3491d6; }
          .SATPlus { color: #1a7b3c; }
          .SAT { color: #43aa55; }
          .BubblePlus { color: #a3d767; }
          .BubbleMinus { color: #e98a3d; }
          .USAT { color: #bf0000; }
          .InProgress, .Incomplete { color: #e1c037; }
          #Answer select { width: 150px; }
          table#MaintenanceAssessmentStudentMastery tbody tr td.Answer {
            min-width: 150px;
            word-wrap: break-word;
          }
          rawscore {
            display: inline-block;
            background-color: White;
            color: Black;
            padding: 1px;
            border-radius: 2px;
            float: right;
            min-width: 18px;
            text-align: center;
          }
          rawscorefixed {
            display: inline-block;
            background-color: White;
            color: Black;
            padding: 1px;
            border-radius: 2px;
            float: right;
            width: 33px;
            text-align: center;
          }
          scalescore {
            display: inline-block;
            padding: 1px;
            float: left;
            min-width: 18px;
            text-align: center;
          }
          img.warningicon {
            width: 14px;
            float: right;
          }
              #maintable {
        width: 985px !important;
    }

        #maintable > tbody > tr > td:first-child {
            width: 750px;
        }

        #maintable td {
            padding: 5px;
            border: 1px solid #331e66;
        }

        #maintable > tbody > tr {
            margin-bottom: 5px;
        }

        #maintable TEKS {
            font-weight: bold;
            padding-right: 1em;
        }

        #maintable .Space {
            height: 10px;
        }

        #maintable tr.QuestionHeader > td {
            padding: 0;
            border: 1px solid #331e66;
        }

            #maintable tr.QuestionHeader > td topbar {
                display: block;
                padding: 5px;
                padding-bottom: 6px;
                margin-bottom: 3px;
                text-align: center;
            }

            #maintable tr.QuestionHeader > td table.DOK, #maintable tr.QuestionHeader > td table.proficiency {
                margin-bottom: 3px;
                width: 100%;
            }

                #maintable tr.QuestionHeader > td table.DOK td, #maintable tr.QuestionHeader > td table.proficiency td {
                    border: none;
                }

        #maintable question {
            display: block;
            padding-top: 10px;
            padding-left: 10px;
            padding-bottom: 10px;
            font-family: "Verdana";
            font-size: 18px;
            line-height: 1.4;
        }

            #maintable question right, #maintable question text {
                display: block;
            }

            #maintable question textanswer {
                display: inline;
                padding: 0 5px 0 5px;
            }

            #maintable question answer {
                display: table;
                margin-top: 18px;
                padding-left: 120px;
                width: 680px;
            }

                #maintable question answer.withmath {
                    margin-top: 20px;
                    margin-bottom: 20px;
                }

                #maintable question answer letter {
                    font-weight: bold;
                    margin-right: 20px;
                    display: inline-block;
                    vertical-align: top;
                    width: 24px;
                    height: 24px;
                    text-align: center;
                    border-radius: 5px;
                    color: red;
                    border: 1px solid red;
                    float: left;
                    font-size: 1.3em;
                }

                #maintable question answer.correct letter {
                    background-color: green;
                    border: 1px solid green;
                    color: White;
                }

                #maintable question answer.incorrect letter {
                    background-color: red;
                    border: 1px solid red;
                    color: White;
                }

                #maintable question answer.theanswer letter {
                    color: green;
                    border: 1px solid green;
                }

                #maintable question answer.withimg letter, #maintable question answer.withmath letter {
                    vertical-align: middle;
                }

                #maintable question answer text {
                    float: left;
                    margin: 0px;
                    padding-left: 5px;
                    display: inline-block;
                    width: 80%;
                }

            #maintable question img {
                margin-top: 30px;
                margin-left: 15px;
                margin-bottom: 15px;
            }

        #maintable table.titlehead {
            border-collapse: separate;
        }

            #maintable table.titlehead tr td {
                border: 0px;
            }

                #maintable table.titlehead tr td:first-child {
                    border-right: 2px solid white;
                    padding: 0px 5px 0px 5px;
                    white-space: nowrap;
                    min-width: 30px;
                    border-bottom: none;
                }

                #maintable table.titlehead tr td:nth-child(0n+2) {
                    border-right: 2px solid white;
                    padding-left: 8px;
                    padding-right: 8px;
                    white-space: nowrap;
                    min-width: 30px;
                    border-bottom: none;
                }

                #maintable table.titlehead tr td:nth-child(0n+3) {
                    width: 99%;
                    border-bottom: none;
                    border-right: none;
                }
    .green {
        color: White !important;
        background-color: #348943 !important;
        border-radius: 0 !important;
        display: revert !important;
    }

    .red {
        color: White !important;
        background-color: Red !important;
    }

    .orange {
        color: White !important;
        background-color: #d64731 !important;
    }

    .gray {
        color: White !important;
        background-color: #838383 !important;
    }

    .yellow {
        color: White !important;
        background-color: #e8b424 !important;
    }

    .purple {
        color: White !important;
        background-color: #7c2a96 !important;
    }

    .blue {
        color: White !important;
        background-color: #331e66 !important;
    }

    .telpasorange {
        color: White !important;
        background-color: #f39c00 !important;
    }

    .telpasgreen {
        color: White !important;
        background-color: #61BD5E !important;
    }

    .telpaspurple {
        color: White !important;
        background-color: #6C6DA9 !important;
    }

    .telpasblue {
        color: White !important;
        background-color: #00ACEF !important;
    }

    .greentext {
        color: #348943 !important;
    }

    .orangetext {
        color: #d64731 !important;
    }

    .purpletext {
        color: #7c2a96 !important;
    }

    .graytext {
        color: #838383 !important;
    }

    .center {
        text-align: center !important;
    }

    .passagehtml.Spaced {
        line-height: 2em;
    }

    .hottext {
        color: #03620b;
        background-color: #cff3c5;
        border: 1px solid #27a403;
        border-radious: 3px;
        padding: 1px;
        padding-left: 3px;
        padding-right: 3px;
        line-height: 1.6em;
    }

    .hottextChecked {
        color: #f9f9f9;
        background-color: #bf11c1;
        border: 2px dotted #f9f9f9;
        color: white;
    }

    .hottext:hover {
        color: #000000;
        background-color: #E8E8E8;
        border: 2px solid #2871BD;
        padding: 0px;
        padding-left: 2px;
        padding-right: 2px;
    }
        `}
      </style>

        {data.questions && data.questions.length === 0 ? (
            <p>No companion questions available for the selected standards.</p>
          ) : (
            data.questions.map((currQuestion, index) => {
              const color = getColor(currQuestion.standardsType);

              let passage = data.passages?.find(
                (p) => p.passageKey === currQuestion.passageKey
              );

              return (
                <div key={index} className="question-container">
                  {passage && passage.passageKey !== lastPassageKey && (
                    <div className={`nobreak passagehtml ${passage.spacing}`}>
                      <table id="maintable">
                        <tbody>
                          <tr>
                          <MathJax>
                            <td
                              style={{ fontSize: `${currQuestion.passagesFontPoint}` }}
                              dangerouslySetInnerHTML={{ __html: formatMathJax(passage.html) }}
                            />
                            </MathJax>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}

                  <table id="maintable" style={{ fontSize: `${currQuestion.questionFontPoint}` }}>
                    <tbody>
                      <tr className="QuestionHeader">
                        <td>
                          <table
                            className="top titlehead center"
                            style={{ fontSize: `${currQuestion.questionFontPoint}` }}
                          >
                            <tbody>
                              <tr
                                className={
                                  currQuestion.omitted
                                    ? 'gray'
                                    : currQuestion.fieldTest
                                    ? 'orange'
                                    : !currQuestion.taught
                                    ? 'yellow'
                                    : 'green'
                                }
                              >
                                <td className="center">{currQuestion.questionNumber}</td>
                                <td className="center">
                                  {currQuestion.omitted
                                    ? 'Omit'
                                    : currQuestion.fieldTest
                                    ? 'F.Test'
                                    : !currQuestion.taught
                                    ? 'N.Taught'
                                    : 'Taught'}
                                </td>
                                <td className={color}>{currQuestion.contentKeyword}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>


                    <tr className="ContentTEKS">
                      <td>
                        <table className="titlehead" style={{ width: '100%' }}>
                          <tr>
                            <td className="center green" style={{ whiteSpace: 'nowrap' }}>
                              C
                            </td>
                            <td className="center green" style={{ whiteSpace: 'nowrap' }}>
                              {currQuestion.contentTEKS}
                            </td>
                            <td style={{ width: '99%', borderRight: 'none' }}>
                              {currQuestion.contentTEKSDesc}
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>

                    {!(currQuestion.processTEKS === "NA" || currQuestion.processTEKSDesc === "NA") && (
                        <tr className="ProcessTEKS">
                            <td>
                            <table className="titlehead" style={{ width: '100%' }}>
                                <tr>
                                <td className="center purple" style={{ whiteSpace: 'nowrap' }}>
                                    P
                                </td>
                                <td className="center purple" style={{ whiteSpace: 'nowrap' }}>
                                    {currQuestion.processTEKS}
                                </td>
                                <td style={{ width: '99%', borderRight: 'none' }}>
                                    {currQuestion.processTEKSDesc}
                                </td>
                                </tr>
                            </table>
                            </td>
                        </tr>
                    )}

                      <tr className="Question">
                        <td>
                          <question name="question">
                            <right> 
                            <MathJax>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: formatMathJax(currQuestion.questionHtml),
                              }}
                            />
                           </MathJax>
                            </right>

                            {currQuestion.questionType === 1 &&
                              currQuestion.answers.map((ans, answerIndex) => (
                                <answer key={answerIndex}>
                                <letter
                                  style={{
                                    color: 'Black',
                                    border: '1px solid Black',
                                    width: `${currQuestion.answerboxWH}`,
                                    height: `${currQuestion.answerboxWH}`,
                                    fontSize: `${currQuestion.questionFontPoint}`,
                                  }}
                                >
                                  {ans.answerLetter}
                                </letter>
                                <MathJax>
                                <text
                                  style={{
                                    width: 'auto!important',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: formatMathJax(ans.answerHtml),
                                  }}
                                />
                                </MathJax>
                              </answer>
                              ))}

                            {(currQuestion.questionType === 2 ||
                              currQuestion.questionType === 6 ||
                              currQuestion.questionType === 7) && (
                                <MathJax>
                            <text>{formatMathJax(currQuestion.bubbleAnswerText)}</text>
                              </MathJax>
                            )}
                          </question>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            })
          )}
      </div>

          {/* Footer */}
          <div
            className="modal-footer"
            style={{
              position: "sticky",
              bottom: 0,
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              backgroundColor: "#519B52",
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              height: "50px",
              padding: "0 20px",
              borderBottomLeftRadius: "10px",
              borderBottomRightRadius: "10px",
              zIndex: 1,
            }}
          >
          <button
            onClick={handlePrint}
            style={{
              border: "1px solid rgb(22, 23, 22)",
              background: "linear-gradient(to bottom, #6FCF70 0%, #519B52 100%)", // Glossy gradient
              color: "#000",
              fontSize: "12px",
              fontWeight: "bold",
              padding: "5px 12px",
              borderRadius: "4px",
              cursor: "pointer",
              margin: "2px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)", // More pronounced shadow
              transition: "background 0.3s ease-in-out, transform 0.2s ease-in-out", // Smooth transitions
            }}
            onMouseOver={(e) => {
              e.target.style.background = "linear-gradient(to bottom, #83E085 0%, #6FCF70 100%)"; // Lighter hover effect
              e.target.style.transform = "scale(1.05)"; // Slight zoom effect
            }}
            onMouseOut={(e) => {
              e.target.style.background = "linear-gradient(to bottom, #6FCF70 0%, #519B52 100%)"; // Revert to original
              e.target.style.transform = "scale(1)"; // Reset zoom
            }}
            >
              Print
            </button>
          </div>  

      </div>
    </div>
    </MathJaxContext>,
    document.body 
  );
};

export default CompanionQuestions;